import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from './constants/enums';

interface StyleProps {
  themeMode: Mode;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  app: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: (props) => props.themeMode === Mode.Dark ? '#464646' : '#D0D0D0',
  }
}));

export default useStyles;
